import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnswerModuleResponse } from '@shared/models/answer-module-response';
import { PreviewMeta as PreviewMetaResponse } from '@shared/models/preview-meta';
import {
  DEFAULT_PREVIEW_STATE,
  PreviewState,
} from '@shared/models/preview/preview-state';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class PreviewService {
  baseURL = '';

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this.baseURL = this.configService.get('ANSWER_SERVICE_API_URL');
  }

  updateStateFromParams(queryParams: any): PreviewState {
  return {
      mode: queryParams.get('mode') || DEFAULT_PREVIEW_STATE.mode,
      rulesInText:
        queryParams.get('showConditions') || DEFAULT_PREVIEW_STATE.rulesInText,
      evalRules: DEFAULT_PREVIEW_STATE.evalRules,
      selectedLanguage:
        queryParams.get('language') || DEFAULT_PREVIEW_STATE.selectedLanguage,
      selectedQuestion: queryParams.get('questionId') || '',
      selectedPage: queryParams.get('pageName') || '',
      sessionId: queryParams.get('sessionId') || DEFAULT_PREVIEW_STATE.sessionId,
    };
  }

  getPreview(
    questId: string,
    language: string,
    mode: string,
    showConditions: string,
    questionId?: string,
    themeId?: string,
    sessionId?: string,
    pageName?: string,
  ): Observable<AnswerModuleResponse> {
    let params = new HttpParams()
      .set('language', language)
      .set('showConditions', showConditions)
      .set('mode', mode);
    if (questionId) {
      params = params.set('questionId', questionId);
    }
    if (themeId) {
      params = params.set('themeId', themeId);
    }
    if(sessionId){
      params = params.set('sessionId', sessionId);
    }
    if (pageName) {
      params = params.set('pageName', pageName);
    }
    if(sessionId){
      params = params.set('sessionId', sessionId);
    }

    return this.http.get<AnswerModuleResponse>(
      this.baseURL + '/api/preview/' + questId,
      {
        params,
      },
    );
  }

  getPreviewMetadata(
    questId: string,
    language?: string,
  ): Observable<PreviewMetaResponse[]> {
    let params = new HttpParams();
    if (language) {
      params = params.set('language', language);
    }

    return this.http.get<PreviewMetaResponse[]>(
      this.baseURL + '/api/preview_meta/' + questId,
      {
        params,
      },
    );
  }

  validateAndSanitizeUrl(baseUrl: string, params: URLSearchParams): string {
    if (!this.isSafeUrl(baseUrl)) {
      throw new Error('Unsafe URL detected');
    }
    return `${baseUrl}?${params.toString()}`;
  }

  private isSafeUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return ['https:', 'http:'].includes(parsedUrl.protocol);
    } catch {
      return false;
    }
  }

  createUrlParams(state: PreviewState): URLSearchParams {
    const params = new URLSearchParams();
    if (state.mode) params.append('mode', state.mode);
    if (state.selectedLanguage)
      params.append('language', state.selectedLanguage);
    if (state.rulesInText) params.append('showConditions', state.rulesInText);
    if (state.evalRules) params.append('evalRules', state.evalRules);
    if (state.selectedQuestion)
      params.append('questionId', state.selectedQuestion);
    if (state.selectedPage) {
      params.append('pageName', state.selectedPage);
    }
    if(state.sessionId) {
      params.append('sessionId', state.sessionId);
    }
    return params;
  }
}
